import {Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, Title} from 'chart.js';
import {Doughnut} from "react-chartjs-2";
import NoItems from "./NoItems";

const ServiceStats = ({serviceStats}) => {

    ChartJS.register(ArcElement, Tooltip, Legend);
    ChartJS.register(
        CategoryScale,
        LinearScale,
        BarElement,
        Title,
    );


    const data = {
        labels: serviceStats?.s,
        datasets: [
            {
                label: 'Foglalások száma',
                data: serviceStats?.r,
                backgroundColor: [
                    'rgba(255, 99, 132, 0.2)',
                    'rgba(54, 162, 235, 0.2)',
                    'rgba(255, 206, 86, 0.2)',
                    'rgba(75, 192, 192, 0.2)',
                    'rgba(153, 102, 255, 0.2)',
                    'rgba(255, 159, 64, 0.2)',
                ],
                borderColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                    'rgba(255, 206, 86, 1)',
                    'rgba(75, 192, 192, 1)',
                    'rgba(153, 102, 255, 1)',
                    'rgba(255, 159, 64, 1)',
                ],
                borderWidth: 1,
            },
        ],
    };
    const sum = serviceStats?.r?.reduce((acc, value) => acc + value, 0)
    if (sum === 0) return <NoItems
        title='Még nincsenek foglalásaid'
        description='Itt fognak megjelenni a foglalási statisztikáid a szolgáltatások bontásában.'
    />
    return <Doughnut data={data} style={{maxHeight: '80%'}}/>
}

export default ServiceStats;